import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "burger-button",
  title: "Menu"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "burger-bar burger-bar--3" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "burger",
    class: _normalizeClass({ active: _ctx.isBurgerActive() }),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _hoisted_1
    ])
  ], 2))
}